import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { ProspectService } from 'src/app/service/prospect.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ExhibitorService } from 'src/app/service/exhibitor.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SecteurService } from 'src/app/service/secteur.service';
import { Subscription, Observable } from 'rxjs';
import { Client } from 'src/app/entity/exhibitor';
import { Contact, Titre } from 'src/app/entity/Contact';
import { ContactService } from 'src/app/service/contact.service';

@Component({
  selector: 'app-contacts-client',
  templateUrl: './contacts-client.component.html',
  styleUrls: ['./contacts-client.component.css']
})
export class ContactsClientComponent implements OnInit, OnDestroy {

  @Input() contactForm: FormGroup;
  routeSub: Subscription
  selectedClient: Client;
  selectedContact: Contact;
  positions: Observable<Titre[]>;
  constructor(private prospectService: ProspectService, private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute, private clientService: ExhibitorService,private router:Router,
    private contactService: ContactService
  ) {
    this.routeSub = this.activatedRoute.params.subscribe(params => {

      if (params['idClient'])
        this.clientService.getExhibitor(params['idClient']).subscribe(result => {
          this.selectedClient = result;

          this.selectedContact = this.selectedClient.contact;
          this.buildContactForm();
          this.onPositionChanges();
        })
    });

  }

  ngOnInit() {


  }
  clickedMe(){
    this.router.navigateByUrl(`/add-exhibitor/${this.selectedClient.idClient}/1`  )  

  }
  onPositionChanges(): void {


    this.contactForm.controls.position.valueChanges.subscribe(val => {

      if (val) {
        const vals = val + "";
        if (vals.length > 0)
          this.positions = this.contactService.getPositionByDesignation(val);


      }
    });
  }
  displayPositionFn(position?: Titre): string | undefined {
    return position ? position.designation : "";

  }


  buildContactForm(): void {

    if (this.selectedContact)
      this.contactForm = this.formBuilder.group({
        'nom': [this.selectedContact.nom, Validators.required],
        'mobile': [this.selectedContact.mobile, Validators.required],
        'tel': [this.selectedContact.tel, Validators.required],
        'mail': [this.selectedContact.mail, Validators.required],
        'position': [this.selectedContact.titreId, Validators.required]
      });
    else {
      this.contactForm = this.formBuilder.group({
        'nom': ['', Validators.required],
        'mobile': ['', Validators.required],
        'tel': ['', Validators.required],
        'mail': ['', Validators.required],
        'position': ['', Validators.required]
      });
    }
  }



  ngOnDestroy(): void {
    this.routeSub.unsubscribe()
  }

}
